// en, ar, etc ...
import en from './lang/en.json'
import ar from './lang/ar.json'

export default {
  en,
  ar
}
